import { useSelector } from "react-redux";
import { user } from "@lhd/features/users/selector";
import { getCompanyId } from "@lhd/utility";

export const useGetWorkerLoggedIn = () => {
  const companyId = getCompanyId();
  const auth = useSelector(user);
  const worker = auth?.workers.find((x) => x.company.id === Number(companyId));
  return worker;
};
